import React from "react";
import MockupSidebar from "./MockupSidebar";
import ListaConversas from "./ListaConversas";
import ChatAtivo from "./ChatAtivo";
import PainelCliente from "./PainelCliente";
import { CORES } from "./dadosMockup";

// Largura/altura de design do mockup (px de design, antes da escala do palco).
export const MOCKUP_LARGURA = 1280;
export const MOCKUP_ALTURA = 720;

// Colunas do /novo-chat/chat: lista | chat | painel, separadas pelo
// divisor de 4px dos react-resizable-panels.
const LARGURA_LISTA = 310;
const LARGURA_PAINEL = 300;

function Divisor() {
  return <div className="w-1 shrink-0" style={{ background: CORES.borda }} />;
}

export default function InboxMockup() {
  return (
    <div
      className="relative flex overflow-hidden rounded-[18px]"
      style={{
        width: MOCKUP_LARGURA,
        height: MOCKUP_ALTURA,
        background: CORES.fundo,
        border: "1px solid rgba(255,255,255,0.1)",
        boxShadow:
          "0 60px 120px -40px rgba(0,0,0,0.9), 0 0 0 1px rgba(255,255,255,0.03), 0 0 90px -10px rgba(34,197,94,0.08)",
      }}
    >
      {/* Brilho de 1px no topo */}
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-px z-10"
        style={{ background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)" }}
      />
      <MockupSidebar />
      <div className="shrink-0 h-full" style={{ width: LARGURA_LISTA }}>
        <ListaConversas />
      </div>
      <Divisor />
      <div className="flex-1 min-w-0 h-full">
        <ChatAtivo />
      </div>
      <Divisor />
      <div className="shrink-0 h-full" style={{ width: LARGURA_PAINEL }}>
        <PainelCliente />
      </div>
    </div>
  );
}
